import { render, staticRenderFns } from "./AuctionsListPage.vue?vue&type=template&id=1f4388d7&scoped=true&"
import script from "./AuctionsListPage.vue?vue&type=script&lang=js&"
export * from "./AuctionsListPage.vue?vue&type=script&lang=js&"
import style0 from "./AuctionsListPage.vue?vue&type=style&index=0&id=1f4388d7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4388d7",
  null
  
)

export default component.exports